import styled from 'styled-components';

export const AdminTableChip = styled.span`
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  color: white;
  display: inline-block;
  font-size: 8px;
  letter-spacing: 1px;
  margin-left: 10px;
  padding: 2px 5px 1px;
  position: relative;
  text-transform: uppercase;
  top: -2px;
`;
